import { render } from "./ModalTable.vue?vue&type=template&id=5fdef2f4&ts=true"
import script from "./ModalTable.vue?vue&type=script&lang=ts"
export * from "./ModalTable.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__